import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function InvoiceMenuItem(props) {
  const navigate = useNavigate();
  const { salonId } = useParams();

  const onMenuItemClicked = () => {
    navigate(Path.salon.deposit.create(salonId, 0));
  };

  return (
    <MainMenuItem
      itemTitleString="請求書を発行する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default InvoiceMenuItem;
